module.exports = __webpack_public_path__ + "img/招聘首页背景.70089a91.png";